'use client';

import { type EventNumber, getEventNumber } from '@svs/nova-poolbetting/schema/sport';
import { useSearchParams } from 'next/navigation';
import type { PropsWithChildren, ReactNode } from 'react';

type CouponEventRowContainerProps = PropsWithChildren & {
  eventNumber: EventNumber;
};

/**
 * Container for coupon event row, used to get selected event in coupon.
 *
 * @param root0 props
 * @param root0.children the children to be rendered inside the container
 * @param root0.eventNumber the number of the event to be displayed, used to see if event is selected
 * @returns the children wrapped in a div with the appropriate class names
 */
export function CouponEventRowContainer({ children, eventNumber }: CouponEventRowContainerProps): ReactNode {
  const searchParams = useSearchParams();

  const selectedEvent = Number.parseInt(searchParams.get('event') ?? '1', 10);
  let selectedEventNumber: number | undefined;
  try {
    selectedEventNumber = getEventNumber(selectedEvent);
  } catch {
    selectedEventNumber = 1;
  }

  const isSelected = selectedEventNumber === eventNumber;

  return (
    <div
      className={
        isSelected
          ? 'lg:before:bg-primary lg:before:absolute lg:before:top-0 lg:before:left-0 lg:before:h-full lg:before:w-1.5 lg:before:rounded-l-md'
          : ''
      }
    >
      {children}
    </div>
  );
}
